import { render, staticRenderFns } from "./AccountInfo.vue?vue&type=template&id=f0f06bd2&"
import script from "./AccountInfo.vue?vue&type=script&lang=js&"
export * from "./AccountInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports